import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Container = styled.div`
  padding: 0 16px;
`;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;

const Paragraph = styled.p`
  margin-bottom: 16px;
  line-height: 1.6;
`;

const List = styled.ul`
  margin-left: 20px;
  list-style-type: disc;
`;

const WhatWeDoTreatments: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="WhatWeDoTreatments">
      <Title>{t("whatWeDo.treatments.title").toUpperCase()}</Title>
      <Paragraph>{t("whatWeDo.treatments.paragraph1")}</Paragraph>
      <Paragraph>{t("whatWeDo.treatments.paragraph2")}</Paragraph>
      <Paragraph>{t("whatWeDo.treatments.paragraph3")}</Paragraph>
      <Paragraph>{t("whatWeDo.treatments.paragraph4")}</Paragraph>
      <List>
        <li>{t("whatWeDo.treatments.tests.riskAssessment")}</li>
        <li>{t("whatWeDo.treatments.tests.ecg")}</li>
        <li>{t("whatWeDo.treatments.tests.echo")}</li>
        <li>{t("whatWeDo.treatments.tests.stress")}</li>
        <li>{t("whatWeDo.treatments.tests.nuclearStress")}</li>
        <li>{t("whatWeDo.treatments.tests.cta")}</li>
        <li>{t("whatWeDo.treatments.tests.calcium")}</li>
        <li>{t("whatWeDo.treatments.tests.pvd")}</li>
        <li>{t("whatWeDo.treatments.tests.mri")}</li>
        <li>{t("whatWeDo.treatments.tests.monitoring")}</li>
      </List>
    </Container>
  );
};

export default WhatWeDoTreatments;
